import { ZCDInput } from '@zencity/common-ui';
import React, { ReactElement } from 'react';
import { FieldTitle } from 'screens/WidgetGenerator/components/FieldTitle/FieldTitle';
import { ReportBuilderFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';

interface Props {
  title: string;
  reportBuilderProps: ReportBuilderFilterProps;
  defaultValue?: number;
  minValue?: number;
  placeholder?: string;
}

export const NumericFilter = (props: Props): ReactElement => {
  const { title, reportBuilderProps, minValue = 0, placeholder, defaultValue } = props;
  const { value: filterValue, onChange } = reportBuilderProps;

  const isFilterValueNaN = Number.isNaN(Number(filterValue));
  const isDefaultValueNaN = Number.isNaN(Number(defaultValue));
  const inputValue = isFilterValueNaN ? undefined : (filterValue as number);

  if (isFilterValueNaN && !isDefaultValueNaN) {
    onChange(defaultValue);
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: targetValue } = event.target;
    onChange(parseInt(targetValue));
  };

  return (
    <>
      <FieldTitle title={title} />
      <ZCDInput type="number" value={inputValue} placeholder={placeholder} min={minValue} onChange={handleOnChange} />
    </>
  );
};
